import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang } = useLanguage();
  return (
    <div
      data-testid="language-toggle"
      role="group"
      aria-label={lang === "es" ? "Seleccionar idioma" : "Select language"}
      className={`inline-flex items-center h-10 p-1 rounded-full border font-mont text-[11px] font-semibold tracking-[0.16em] ${className}`}
      style={{borderColor:"var(--kd9-border)",background:"var(--kd9-accent-soft)"}}
      translate="no"
    >
      {["es","en"].map((code)=>(
        <button
          key={code}
          type="button"
          onClick={()=>setLang(code)}
          aria-pressed={lang===code}
          aria-label={code==="es"?"Usar español":"Use English"}
          data-testid={`language-${code}`}
          className="h-8 min-w-10 px-2 rounded-full transition-all duration-200"
          style={{
            color:lang===code?"#070707":"var(--kd9-text-soft)",
            background:lang===code?"var(--kd9-accent)":"transparent",
            opacity:lang===code?1:0.75,
          }}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
export default LanguageToggle;
